<!-- 充值记录对话框 -->
<template>
    <el-dialog class="dialog" :visible.sync="recordDialogShow" width="800px" @close="closeDialog" :close-on-click-modal="false" :append-to-body="true"> 
        <el-collapse v-infinite-scroll="orderScroll">
            <div v-if="orderList.length > 0">
                <el-collapse-item v-for="(item, key) of orderList" :key="key">
                    <template slot="title">
                        <div class="coll_img" :style="{ 'backgroundImage': 'url(' + item.goodsIcon + ')' }"></div>
                        <div class="coll_name">{{ item.subOrderCount > 1 ? $t('multiName') : item.goodsName }}</div>
                        <div class="coll_time">{{ formatDate(parseInt(item.createTime)) }}</div>
                        <div class="coll_status">{{ formatStatus(item.status) }}</div>
                    </template>
                    <div v-for="(i, k) of item.subOrderList" :key="k">
                        <p>{{ i.goodsName }}({{ i.goodsCount }}){{ $t('countNum') }}</p>
                        <p>{{ $t('priceLoading') }}{{ i.successCount }}/{{ i.totalCount }}</p>
                    </div>
                    <!-- <p>{{$t('priceLoading')}}{{formatStatus(item.status)}}</p> -->
                    <p>{{ $t('orderID') }}{{ item.orderId }}</p>
                    <p>{{ $t('accountUID') }}{{ item.uid }}</p>
                    <p>{{ $t('totalAmount') }}{{item.currency == "POINT"
                    ? $t("rebatePoint"):allGearData.currencyList.filter(v => v.currency ==
                        item.currency)[0].currencyMark}}
                        {{ item.totalMoney }}</p>
                    <p>{{ $t('paymentChannel') }}{{ item.orderType }}</p>
                    <p>{{ $t('orderCreationTime') }}{{ formatDate(parseInt(item.createTime)) }}</p>
                    <p v-if="item.serverName">{{ $t('serverName') }} {{ item.serverName }}</p>
                    <p>{{ $t('roleName') }} {{ item.roleName }}</p>
                    <p v-if="item.rebateCount && item.rebateCount !== '0'">
                        {{ $t("rebateGet", { msg: item.rebateCount }) }}
                    </p>
                    <p v-if="
                        item.weekEndRebateCount && item.weekEndRebateCount !== '0'
                    ">
                        {{ $t("weekEndRebateCount", { msg: item.weekEndRebateCount }) }}
                    </p>
                </el-collapse-item>
                <p v-if="orderLoad">{{ $t('loading') }}</p>
                <p v-if="noMore" style="text-align: center;">{{ $t('noMore') }}</p>
            </div>
            <div v-if="orderList.length == 0 && orderLoading == 'loaded'">
                <p style="line-height: 300px; font-size: 20px; margin: 0; padding: 0;">{{ $t('noMore') }}</p>
            </div>
            <div v-if="orderList.length == 0 && orderLoading == 'loading'">
                <p style="line-height: 300px; font-size: 20px; margin: 0; padding: 0;"><span
                        class="el-icon-loading"></span>{{ $t('loading') }}</p>
            </div>
        </el-collapse>
    </el-dialog>
</template>
<script>
import moment from "moment";
import { mapGetters, mapActions } from 'vuex'
export default {
    name: "RechargeRecord",
    components: {},
    data() {
        return {
            recordDialogShow: true,
            storage: {},
            orderList: [],
            orderLoad: false,// 加载数据
            noMore: false,
            pageNumber: 0,
            totalPage: 0,
        };
    },
    computed: {
        ...mapGetters(["allGearData", 'orderInfo', 'orderLoading']),
        formatDate: (val) => {
            return (val) => {
                return moment(val).format("YYYY-MM-DD HH:mm:ss");
            };
        },
        formatStatus: ($vm) => {
            return (val) => {
                if (val == "0") {
                    return $vm.$t("toBePaid");
                } else if (val == "100") {
                    return $vm.$t("tradeSuccess");
                }
            };
        },
    },
    mounted() {
        this.storage = JSON.parse(window.localStorage.getItem("storage"));
        this.orderScroll(true)
    },
    watch: {
        orderLoading(val) {
            if (val === "loaded") {
                this.orderInfo.list.map((val) => { this.orderList.push(val); });
                this.totalPage = this.orderInfo.totalPage;
                this.orderLoad = false;
            }
        }
    },
    methods: {
        ...mapActions(["getThirdPayOrderList",]),

        closeDialog() {
            this.$emit("closeDialog");
        },
        orderScroll(initial = false) {
            if ((this.totalPage > this.pageNumber || initial) && !this.orderLoad) {
                this.pageNumber += 1
                this.orderLoad = true
                this.getThirdPayOrderList({
                    uid: this.storage.uid,
                    accessToken: this.storage.accessToken,
                    pageNumber: this.pageNumber,
                    language: window.localStorage.getItem('language'),
                    appId: CONFIG.appId,
                    serverId: this.storage.serverId,
                    roleId: this.storage.roleId,
                    areaId: this.storage.areaId,
                })
            } else if (this.totalPage == this.pageNumber) {
                this.noMore = true
            }
        },
    },
};
</script>
<style lang="scss"></style>
